import { render, staticRenderFns } from "./caFaq.vue?vue&type=template&id=4b6341ff"
import script from "./caFaq.vue?vue&type=script&lang=js"
export * from "./caFaq.vue?vue&type=script&lang=js"
import style0 from "./caFaq.vue?vue&type=style&index=0&id=4b6341ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports